<template>
    <div id="controls">
        <div v-if="playback">
            <div class="hidden-md-and-down">
                <v-row align="center" justify="center">
                    <v-spacer />
                    <v-col cols="3" class="text-align--center">
                        <img
                            :src="track_info.album.artwork_url"
                            id="album_artwork"
                            @click="retrieve_currently_playing_information"
                        />
                    </v-col>
                    <v-col cols="3">
                        <div id="name_metadata">
                            <h2
                                id="song_name"
                                v-text="
                                    `${track_info.title} ${
                                        track_info.explicit ? '(Explicit)' : ''
                                    }`
                                "
                                @click="dev_function"
                            />
                            <span id="artists" v-text="pp_artists" />
                            <br />
                            <span
                                id="album_name"
                                v-text="track_info.album.name"
                            />
                            <br />
                            <span
                                id="playlist_name"
                                v-if="context.playlist_info.id !== null"
                                v-text="context.playlist_info.name"
                                @click="context.track_list_dialog = true"
                            />
                        </div>
                        <br />
                        <br />
                        <v-row
                            align="center"
                            justify="center"
                            id="playback_controls"
                        >
                            <v-col>
                                <v-btn fab icon @click="skip_previous_track">
                                    <v-icon>mdi-skip-previous</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn
                                    fab
                                    icon
                                    v-if="playing"
                                    @click="pause_playback"
                                >
                                    <v-icon>mdi-pause</v-icon>
                                </v-btn>
                                <v-btn
                                    fab
                                    icon
                                    v-if="!playing"
                                    @click="resume_playback"
                                >
                                    <v-icon>mdi-play</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="skip_next_track">
                                    <v-icon>mdi-skip-next</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center"
                            id="extra_controls"
                        >
                            <v-col>
                                <v-btn fab icon @click="toggle_saved">
                                    <v-icon v-if="track_info.saved">
                                        mdi-heart
                                    </v-icon>
                                    <v-icon color="secondary" v-else>
                                        mdi-heart-outline
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="toggle_shuffle">
                                    <v-icon
                                        :color="
                                            shuffle ? 'primary' : 'secondary'
                                        "
                                    >
                                        mdi-shuffle
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="toggle_repeat">
                                    <v-icon v-if="repeat === 'context'">
                                        mdi-repeat
                                    </v-icon>
                                    <v-icon v-if="repeat === 'track'">
                                        mdi-repeat-once
                                    </v-icon>
                                    <v-icon
                                        color="secondary"
                                        v-if="
                                            repeat === 'off' || repeat === null
                                        "
                                    >
                                        mdi-repeat-off
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="volume.dialog = true">
                                    <v-icon
                                        :color="
                                            playing ? 'primary' : 'secondary'
                                        "
                                        v-text="icon_volume(volume.spotify)"
                                    />
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="devices_dialog = true">
                                    <v-icon
                                        :color="
                                            playing ? 'primary' : 'secondary'
                                        "
                                        v-text="active_device.icon"
                                    ></v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn fab icon @click="open_playlists_dialog">
                                    <v-icon>mdi-playlist-music-outline</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer />
                </v-row>
                <v-row align="center" justify="center">
                    <v-spacer />
                    <v-col cols="9">
                        <v-progress-linear
                            color="accent lighten-1"
                            background-color="accent lighten-4"
                            :value="
                                (track_info.progress / track_info.duration) *
                                    100
                            "
                        ></v-progress-linear>
                        <v-row dense>
                            <v-spacer />
                            <v-col class="text-align--right">
                                <span class="text-size--small">
                                    {{ progress_minsec }} /
                                    {{ duration_minsec }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>
            <div class="hidden-lg-and-up">
                <v-row align="center" justify="center">
                    <v-card width="350">
                        <v-img
                            class="align-end"
                            width="100%"
                            id="album_artwork"
                            :src="track_info.album.artwork_url"
                            @click="retrieve_currently_playing_information"
                        />
                        <v-card-text>
                            <div id="name_metadata">
                                <h3 id="song_name" v-text="track_info.title" />
                                <span id="artists" v-text="pp_artists" />
                                <br />
                                <span
                                    id="album_name"
                                    v-text="track_info.album.name"
                                />
                                <br />
                                <span
                                    id="playlist_name"
                                    v-if="context.playlist_info.id !== null"
                                    v-text="context.playlist_info.name"
                                    @click="context.track_list_dialog = true"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card width="350" class="ma-2" outlined>
                        <v-card-text>
                            <v-row align="center" justify="center" dense>
                                <v-col>
                                    <v-btn fab icon @click="toggle_saved">
                                        <v-icon v-if="track_info.saved">
                                            mdi-heart
                                        </v-icon>
                                        <v-icon color="secondary" v-else>
                                            mdi-heart-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn fab icon @click="toggle_shuffle">
                                        <v-icon
                                            :color="
                                                shuffle
                                                    ? 'primary'
                                                    : 'secondary'
                                            "
                                        >
                                            mdi-shuffle
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn fab icon @click="toggle_repeat">
                                        <v-icon v-if="repeat === 'context'">
                                            mdi-repeat
                                        </v-icon>
                                        <v-icon v-if="repeat === 'track'">
                                            mdi-repeat-once
                                        </v-icon>
                                        <v-icon
                                            color="secondary"
                                            v-if="
                                                repeat === 'off' ||
                                                    repeat === null
                                            "
                                        >
                                            mdi-repeat-off
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        fab
                                        icon
                                        @click="volume.dialog = true"
                                    >
                                        <v-icon
                                            :color="
                                                playing
                                                    ? 'primary'
                                                    : 'secondary'
                                            "
                                            v-text="icon_volume(volume.spotify)"
                                        />
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        fab
                                        icon
                                        @click="devices_dialog = true"
                                    >
                                        <v-icon
                                            :color="
                                                playing
                                                    ? 'primary'
                                                    : 'secondary'
                                            "
                                            v-text="active_device.icon"
                                        ></v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        fab
                                        icon
                                        @click="open_playlists_dialog"
                                    >
                                        <v-icon
                                            >mdi-playlist-music-outline</v-icon
                                        >
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-divider />
                            <v-row
                                align="center"
                                justify="center"
                                id="playback_controls"
                            >
                                <v-col>
                                    <v-btn
                                        fab
                                        icon
                                        @click="skip_previous_track"
                                    >
                                        <v-icon>mdi-skip-previous</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        fab
                                        icon
                                        v-if="playing"
                                        @click="pause_playback"
                                    >
                                        <v-icon>mdi-pause</v-icon>
                                    </v-btn>
                                    <v-btn
                                        fab
                                        icon
                                        v-if="!playing"
                                        @click="resume_playback"
                                    >
                                        <v-icon>mdi-play</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn fab icon @click="skip_next_track">
                                        <v-icon>mdi-skip-next</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-row>

                <v-row align="center" justify="center">
                    <v-spacer />
                    <v-col cols="10">
                        <v-progress-linear
                            color="accent lighten-1"
                            background-color="accent lighten-4"
                            :value="
                                (track_info.progress / track_info.duration) *
                                    100
                            "
                        ></v-progress-linear>
                        <v-row dense>
                            <v-spacer />
                            <v-col class="text-align--right">
                                <span class="text-size--small">
                                    {{ progress_minsec }} /
                                    {{ duration_minsec }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>
        </div>

        <v-row align="center" justify="center" v-else>
            <v-spacer />
            <v-col cols="10" lg="5">
                <v-card class="ma-2" :outlined="$vuetify.theme.dark">
                    <v-card-title>
                        No Music Playing
                    </v-card-title>
                    <v-card-text>
                        At the moment, no music is playing. Start playing music
                        and Control Surface for Spotify will switch to the
                        controller interface. If you do not specify a device to
                        output to, the first device in the list will be used.
                        Press "D" or the devices button below to change the
                        output device.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn fab icon @click="skip_previous_track">
                            <v-icon>mdi-skip-previous</v-icon>
                        </v-btn>
                        <v-btn fab icon v-if="playing" @click="pause_playback">
                            <v-icon>mdi-pause</v-icon>
                        </v-btn>
                        <v-btn
                            fab
                            icon
                            v-if="!playing"
                            @click="resume_playback"
                        >
                            <v-icon>mdi-play</v-icon>
                        </v-btn>
                        <v-btn fab icon @click="skip_next_track">
                            <v-icon>mdi-skip-next</v-icon>
                        </v-btn>
                        <v-btn fab icon @click="devices_dialog = true">
                            <v-icon>mdi-devices</v-icon>
                        </v-btn>

                        <v-spacer />
                    </v-card-actions>
                </v-card>

                <v-card class="ma-2" :outlined="$vuetify.theme.dark">
                    <v-card-title>
                        Playlists
                        <v-spacer />
                        <v-btn icon @click="retrieve_playlists(true)">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            @click="
                                show_playlists = !show_playlists;
                                if (show_playlists === true) {
                                    retrieve_playlists();
                                }
                            "
                        >
                            <v-icon v-if="!show_playlists">
                                mdi-chevron-down
                            </v-icon>
                            <v-icon v-else>
                                mdi-chevron-up
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="show_playlists">
                            <v-list-item
                                three-line
                                v-for="playlist of playlists"
                                :key="playlist.id"
                                @click="start_playlist(playlist.uri)"
                            >
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="playlist.name"
                                    ></v-list-item-title>
                                    <v-list-item-subtitle>
                                        Owner:
                                        {{ playlist.owner.info.display_name }} |
                                        Tracks: {{ playlist.tracks.total }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-text="playlist.description"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-icon>
                                    <v-btn icon>
                                        <v-icon>mdi-play-outline</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-spacer />
        </v-row>

        <v-dialog v-model="devices_dialog" width="500">
            <v-card>
                <v-card-title>
                    Output Device
                    <v-spacer />
                    <v-btn icon @click="devices_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div v-if="active_device.id">
                        <v-select
                            :prepend-icon="active_device_icon"
                            :items="devices_list"
                            :value="active_device.id"
                            readonly
                        />
                        <span v-if="devices_list.length === 1">
                            No other devices are available to transfer playback
                            to.
                        </span>
                        <div v-if="devices_list.length > 1">
                            <v-select
                                :prepend-icon="active_device_icon"
                                :items="devices_list"
                                v-model="active_device_id"
                            />
                            <v-btn
                                block
                                color="accent"
                                :disabled="
                                    active_device_id === active_device.id
                                "
                                @click="transfer_playback(active_device_id)"
                            >
                                Transfer Playback
                            </v-btn>
                        </div>
                    </div>
                    <div v-else>
                        <v-select
                            prepend-icon="mdi-devices"
                            :items="devices_list"
                            v-model="active_device_id"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="volume.dialog" width="500">
            <v-card>
                <v-card-title>
                    Volume
                    <v-spacer />
                    <v-btn icon @click="volume.dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-slider
                        v-model="volume.spotify"
                        :prepend-icon="icon_volume(volume.spotify)"
                        inverse-label
                        :label="`${this.volume.spotify}%`"
                        readonly
                    ></v-slider>
                    <v-slider
                        v-model="volume.user"
                        :prepend-icon="icon_volume(volume.user)"
                        inverse-label
                        :label="`${this.volume.user}%`"
                    ></v-slider>
                    <v-btn
                        text
                        block
                        @click="set_volume()"
                        :disabled="volume.spotify === volume.user"
                    >
                        Set Volume
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="playlists_dialog" width="750" scrollable>
            <v-card>
                <v-card-title>
                    Playlists
                    <v-spacer />
                    <v-btn icon @click="retrieve_playlists(true)">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn icon @click="playlists_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-list-item
                        three-line
                        v-for="playlist of playlists"
                        :key="playlist.id"
                        @click="
                            start_playlist(
                                playlist.uri,
                                playlist.uri === context.uri
                            )
                        "
                    >
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="playlist.name"
                            ></v-list-item-title>
                            <v-list-item-subtitle>
                                Owner:
                                {{ playlist.owner.info.display_name }} | Tracks:
                                {{ playlist.tracks.total }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-text="playlist.description"
                            ></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-btn icon v-if="playlist.uri !== context.uri">
                                <v-icon>
                                    mdi-play-outline
                                </v-icon>
                            </v-btn>
                            <v-btn text color="accent" v-else>
                                {{ playing ? "Playing" : "Paused" }}
                            </v-btn>
                        </v-list-item-icon>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="context.track_list_dialog"
            width="750"
            v-if="context.playlist_info.tracks !== null"
            scrollable
        >
            <v-card>
                <v-card-title>
                    {{ context.playlist_info.name }}
                    <v-spacer />
                    <v-btn icon @click="context.track_list_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-list-item
                        three-line
                        v-for="item of context.playlist_info.tracks.items"
                        :key="item.track.id"
                        :id="item.track.id"
                        @click="
                            start_playlist_track(
                                item.track.uri,
                                track_info.id === item.track.id
                            )
                        "
                    >
                        <v-list-item-content>
                            <v-list-item-title
                                :class="{
                                    'accent--text':
                                        track_info.id === item.track.id
                                }"
                                v-text="item.track.name"
                            />
                            <v-list-item-subtitle
                                class="text-style--bold"
                                :class="{
                                    'accent--text':
                                        track_info.id === item.track.id
                                }"
                                v-text="prettyprint_artists(item.track.artists)"
                            />
                            <v-list-item-subtitle
                                :class="{
                                    'accent--text':
                                        track_info.id === item.track.id
                                }"
                                v-text="item.track.album.name"
                            />
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon
                                v-if="
                                    track_info.id === item.track.id && playing
                                "
                                :color="
                                    track_info.id === item.track.id
                                        ? 'accent'
                                        : ''
                                "
                            >
                                mdi-pause
                            </v-icon>
                            <v-icon
                                :color="
                                    track_info.id === item.track.id
                                        ? 'accent'
                                        : ''
                                "
                                v-else
                            >
                                mdi-play-outline
                            </v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="error.snackbar"
            :timeout="error.snackbar_timeout"
            absolute
            bottom
            right
            color="error"
            :outlined="$vuetify.theme.dark"
        >
            {{ error.message }}
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: "Controller",
    data: function() {
        return {
            playback: false,
            context: {
                type: "",
                uri: "",
                playlist_info: {
                    id: null,
                    name: null,
                    uri: null,
                    description: null,
                    owner: null,
                    public: null,
                    collaborative: null,
                    tracks: null
                },
                track_list_dialog: false
            },
            track_info: {
                id: "",
                title: "",
                artists: [],
                album: {
                    id: null,
                    name: null,
                    artwork_url: null
                },
                progress: 0,
                duration: 0,
                saved: false,
                explicit: null
            },
            volume: {
                spotify: 0,
                user: 0,
                dialog: false
            },
            playing: false,
            shuffle: false,
            repeat: null,
            active_device: {
                id: "",
                name: "",
                icon: "",
                type: ""
            },
            user: null,
            playlists: [],
            show_playlists: false,
            playlists_dialog: false,
            active_device_id: false,
            devices_list: [],
            devices_dict: {},
            devices_dialog: false,
            device_icons: {
                Computer: "desktop-mac",
                Tablet: "tablet-ipad",
                Smartphone: "cellphone",
                Speaker: "speaker",
                TV: "television",
                AVR: "audio-video",
                STB: "set-top-box",
                AudioDongle: "speaker-wireless",
                GameConsole: "microsoft-xbox-controller",
                CastVideo: "cast",
                CastAudio: "cast-audio",
                Automobile: "car-outline",
                Unknown: "progress-question"
            },
            error: {
                snackbar: false,
                snackbar_timeout: 3000,
                message: ""
            },
            refresh: {
                interval: null,
                interval_start: null
            },
            request_retryafter: {
                seconds: null,
                start: null
            },
            main_interval: ""
        };
    },
    created() {
        if (this.$spotify_credentials.access_token === "") {
            this.$router.push("/authorize");
        }
    },
    mounted() {
        this.main();
        this.load_user_data();

        this.main_interval = setInterval(this.main, 1000);
        this.start_refresh_interval(
            this.$spotify_credentials.expires_in - 1900
        );

        document.onkeydown = this.handle_keystrokes;
    },
    computed: {
        pp_artists: function() {
            return this.track_info.artists.join(", ");
        },
        active_device_icon: function() {
            if (
                typeof this.get_device_information(this.active_device_id) !==
                "undefined"
            ) {
                return this.get_device_information(this.active_device_id).icon;
            } else {
                return "mdi-devices";
            }
        },
        progress_minsec: function() {
            let ms = new Date(this.track_info.progress),
                seconds =
                    ms.getUTCSeconds() < 10
                        ? `0${ms.getUTCSeconds()}`
                        : ms.getUTCSeconds();
            return ms.getUTCMinutes() + ":" + seconds;
        },
        duration_minsec: function() {
            let ms = new Date(this.track_info.duration),
                seconds =
                    ms.getUTCSeconds() < 10
                        ? `0${ms.getUTCSeconds()}`
                        : ms.getUTCSeconds();
            return ms.getUTCMinutes() + ":" + seconds;
        }
    },
    methods: {
        open_playlists_dialog: function() {
            this.retrieve_playlists();
            this.playlists_dialog = true;
        },
        request_precheck: function() {
            let retryafter = true;
            if (this.request_retryafter.start !== null) {
                retryafter =
                    new Date().getTime() - this.request_retryafter.start >=
                    this.request_retryafter.seconds * 5000;
                if (
                    new Date().getTime() - this.request_retryafter.start >=
                    this.request_retryafter.seconds * 5000
                ) {
                    this.request_retryafter.seconds = null;
                    this.request_retryafter.start = null;
                }
            }

            if (this.$spotify_credentials.access_token !== "" && retryafter) {
                return true;
            } else {
                return false;
            }
        },
        handle_errors: function(
            error,
            function_code,
            options = {
                user: false,
                console: true,
                messages: { unknown: null }
            }
        ) {
            let status = error.data.error.status,
                reason = error.data.error.reason,
                message = error.data.error.message;

            let d = new Date();

            if (status === 403 && reason === "UNKNOWN") {
                if (options.user) {
                    this.error.message = options.messages.unknown;
                    this.error.snackbar = true;
                }
            } else if (
                status === 401 &&
                message === "The access token expired"
            ) {
                this.retrieve_new_tokens(true);
            } else if (
                status === 429 &&
                message === "API rate limit exceeded"
            ) {
                console.info(
                    `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] [${function_code}] 429: API rate-limiting engaged, resuming requests in ${Number(
                        error.headers["retry-after"]
                    )} second(s).`
                );
                this.request_retryafter.seconds = Number(
                    error.headers["retry-after"]
                );
                this.request_retryafter.start = new Date().getTime();
            }

            if (status !== 429 && message !== "API rate limit exceeded") {
                this.request_retryafter.seconds = null;
                this.request_retryafter.start = null;
            }

            if (options.console)
                console.error(
                    `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] [${function_code}] ${status}: ${reason} (${message})`
                );
        },
        icon_volume: function(volume) {
            if (volume === 0) {
                return "mdi-volume-mute";
            } else if (volume > 0 && volume <= 25) {
                return "mdi-volume-low";
            } else if (volume > 25 && volume <= 50) {
                return "mdi-volume-medium";
            } else if (volume > 50) {
                return "mdi-volume-high";
            }
        },
        set_volume: function(volume = this.volume.user) {
            if (this.request_precheck()) {
                this.$axios
                    .put("https://api.spotify.com/v1/me/player/volume", null, {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                            "Content-Type": "application/json"
                        },
                        params: {
                            volume_percent: volume
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "SV", options);
                        }
                    });

                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        start_playlist_track: function(track_uri, active = false) {
            if (this.request_precheck()) {
                if (!active) {
                    this.$axios
                        .put(
                            "https://api.spotify.com/v1/me/player/play",
                            {
                                uris: Array(track_uri)
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                                    "Content-Type": "application/json"
                                }
                            }
                        )
                        .catch(error => {
                            if (error.response) {
                                let options = {
                                    user: false,
                                    console: true
                                };
                                this.handle_errors(
                                    error.response,
                                    "SPT",
                                    options
                                );
                            }
                        });
                } else {
                    if (this.playing) {
                        this.pause_playback();
                    } else {
                        this.resume_playback();
                    }
                }

                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        prettyprint_artists: function(artists_object) {
            return artists_object.map(artist => artist.name).join(", ");
        },
        dev_function: function() {
            if (this.$NODE_ENV === "development") {
                this.retrieve_new_tokens(true);
                /*
                console.log(this.track_info);
                console.log(this.context.playlist_info.tracks.items);
                console.log(
                    this.context.playlist_info.tracks.items.find(
                        item => item.track.id === this.track_info.id
                    )
                );
                console.log(
                    this.context.playlist_info.tracks.items.findIndex(
                        item => item.track.id === this.track_info.id
                    ) + 1
                );
                console.log(this.context.playlist_info.tracks.items[0]);*/
            }
        },
        playlist_information_callback: function(spotify_response) {
            this.context.playlist_info.id = spotify_response.id;
            this.context.playlist_info.name = spotify_response.name;
            this.context.playlist_info.uri = spotify_response.uri;
            this.context.playlist_info.description =
                spotify_response.description;
            this.context.playlist_info.owner = spotify_response.owner;
            this.context.playlist_info.public = spotify_response.public;
            this.context.playlist_info.collaborative =
                spotify_response.collaborative;
            this.context.playlist_info.tracks = spotify_response.tracks;
        },
        get_playlist_details: function(playlist_id, callback) {
            if (this.request_precheck()) {
                this.$axios
                    .get(
                        `https://api.spotify.com/v1/playlists/${playlist_id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                            }
                        }
                    )
                    .then(response => callback(response.data))
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "GPD", options);
                        }
                    });
            }
        },
        start_playlist: function(playlist_uri, playing = false) {
            if (this.request_precheck()) {
                if (!playing) {
                    let device_id =
                        this.active_device.id ||
                        this.active_device_id ||
                        this.devices[0].id;

                    this.$axios
                        .put(
                            "https://api.spotify.com/v1/me/player/play",
                            {
                                context_uri: playlist_uri
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                                    "Content-Type": "application/json"
                                },
                                params: {
                                    device_id: device_id
                                }
                            }
                        )
                        .catch(error => {
                            if (error.response) {
                                let options = {
                                    user: false,
                                    console: true
                                };
                                this.handle_errors(
                                    error.response,
                                    "SP",
                                    options
                                );
                            }
                        });
                } else {
                    if (this.playing) {
                        this.pause_playback();
                    } else {
                        this.resume_playback();
                    }
                }

                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        load_user_data: function() {
            if (this.request_precheck()) {
                this.$axios
                    .get("https://api.spotify.com/v1/me", {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        }
                    })
                    .then(response => response.data)
                    .then(data => {
                        this.user = {
                            id: data.id,
                            display_name: data.display_name,
                            country: data.country
                        };
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "LUD", options);
                        }
                    });
            }
        },
        load_playlists: function(spotify_response, reset_array = false) {
            if (reset_array) {
                this.playlists = [];
            }
            for (let playlist of spotify_response.items) {
                if (
                    this.playlists.find(pl => pl.id === playlist.id) ===
                    undefined
                ) {
                    this.playlists.push({
                        id: playlist.id,
                        name: playlist.name,
                        description: playlist.description,
                        owner: {
                            signed_in_user:
                                playlist.owner.display_name ===
                                this.user.display_name,
                            info: playlist.owner
                        },
                        public: playlist.public,
                        collaborative: playlist.collaborative,
                        uri: playlist.uri,
                        tracks: playlist.tracks
                    });
                }
            }
        },
        retrieve_playlists: function(reset_array = false) {
            if (this.request_precheck()) {
                this.$axios
                    .get("https://api.spotify.com/v1/me/playlists", {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        }
                    })
                    .then(response =>
                        this.load_playlists(response.data, reset_array)
                    )
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "RP", options);
                        }
                    });
            }
        },
        toggle_repeat: function() {
            let mode = "";
            if (this.repeat === "off" || this.repeat === null) {
                mode = "context";
            } else if (this.repeat === "context") {
                mode = "track";
            } else if (this.repeat === "track") {
                mode = "off";
            }

            this.$axios
                .put("https://api.spotify.com/v1/me/player/repeat", null, {
                    headers: {
                        Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                        "Content-Type": "application/json"
                    },
                    params: {
                        state: mode
                    }
                })
                .catch(error => {
                    if (error.response) {
                        let options = {
                            user: true,
                            console: true,
                            messages: {
                                unknown:
                                    "An unknown error occurred when setting the repeat state."
                            }
                        };
                        this.handle_errors(error.response, "TR", options);
                    }
                });

            setTimeout(this.retrieve_currently_playing_information, 750);
        },
        toggle_saved: function() {
            if (this.request_precheck()) {
                let endpoint = "https://api.spotify.com/v1/me/tracks";
                if (this.track_info.saved) {
                    this.$axios
                        .delete(endpoint, {
                            headers: {
                                Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                            },
                            params: { ids: this.track_info.id }
                        })
                        .catch(error => {
                            if (error.response) {
                                let options = {
                                    user: false,
                                    console: true
                                };
                                this.handle_errors(
                                    error.response,
                                    "TST.remove",
                                    options
                                );
                            }
                        });
                } else {
                    this.$axios
                        .put(
                            endpoint,
                            {
                                ids: [this.track_info.id]
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                                    "Content-Type": "application/json"
                                }
                            }
                        )
                        .catch(error => {
                            if (error.response) {
                                let options = {
                                    user: false,
                                    console: true
                                };
                                this.handle_errors(
                                    error.response,
                                    "TST.add",
                                    options
                                );
                            }
                        });
                }
                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        check_saved: function(track_id) {
            if (this.request_precheck()) {
                this.$axios
                    .get("https://api.spotify.com/v1/me/tracks/contains", {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        },
                        params: {
                            ids: track_id
                        }
                    })
                    .then(response => {
                        this.track_info.saved = response.data[0];
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "CST", options);
                        }
                        return null;
                    });
            }
        },
        toggle_shuffle: function() {
            if (this.request_precheck()) {
                this.$axios
                    .put("https://api.spotify.com/v1/me/player/shuffle", null, {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        },
                        params: {
                            state: !this.shuffle
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: true,
                                console: true,
                                messages: {
                                    unknown:
                                        "An unknown error occurred when setting the shuffle state."
                                }
                            };
                            this.handle_errors(error.response, "TS", options);
                        }
                    });
                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        handle_keystrokes: function(event_obj) {
            let event_object = window.event ? event : event_obj;
            if (event_object.keyCode === 32) {
                // Spacebar
                if (this.playing) {
                    this.pause_playback();
                } else {
                    this.resume_playback();
                }
            } else if (event_object.keyCode === 37) {
                // Left Arrow
                this.skip_previous_track();
            } else if (event_object.keyCode === 39) {
                // Right Arrow
                this.skip_next_track();
            } else if (
                (event_object.ctrlKey || event_object.metaKey) &&
                event_object.keyCode === 83
            ) {
                // Control/Meta + S
                event_object.preventDefault();
                this.toggle_saved();
            } else if (event_object.keyCode === 68) {
                // D
                this.devices_dialog = true;
            } else if (event_object.keyCode === 83) {
                // S
                this.toggle_shuffle();
            } else if (event_object.keyCode === 82) {
                // R
                this.toggle_repeat();
            } else if (event_object.keyCode === 78) {
                // N
                this.$event_hub.$emit("open-notes");
            } else if (event_object.keyCode === 80) {
                // P
                if (this.playback) {
                    this.open_playlists_dialog();
                }
            } else if (event_object.keyCode === 84 && !event_object.shiftKey) {
                // T
                if (this.context.type === "playlist") {
                    this.context.track_list_dialog = true;
                }
            } else if (event_object.keyCode === 86) {
                // V
                this.volume.dialog = true;
            } else if (event_object.keyCode === 38) {
                // Up Arrow
                this.set_volume(this.volume.spotify + 1);
            } else if (event_object.keyCode === 40) {
                // Down Arrow
                this.set_volume(this.volume.spotify - 1);
            } else if (event_object.shiftKey && event_object.keyCode === 84) {
                // Shift + T
                this.$event_hub.$emit("toggle-theme");
            } else if (event_object.shiftKey && event_object.keyCode === 87) {
                // Shift + W
                this.$event_hub.$emit("signout");
            } else if (event_object.keyCode === 27) {
                // Escape (if dialogs are open)
                this.devices_dialog = false;
                this.playlists_dialog = false;
                this.context.track_list_dialog = false;
                this.volume.dialog = false;
                this.$event_hub.$emit("close-notes");
                this.$event_hub.$emit("close-signout-confirmation");
            }
        },
        transfer_playback: function(device_id) {
            if (this.request_precheck()) {
                this.$axios
                    .put(
                        "https://api.spotify.com/v1/me/player",
                        {
                            device_ids: [device_id],
                            play: true
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${this.$spotify_credentials.access_token}`,
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            }
                        }
                    )
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "TPB", options);
                        }
                    });
                setTimeout(this.retrieve_currently_playing_information, 750);
            }
        },
        main: function() {
            this.retrieve_currently_playing_information();
            this.retrieve_available_devices();
        },
        get_device_information: function(id) {
            return this.devices_dict[id];
        },
        pause_playback: function() {
            this.no_response_axios_put_request(
                "https://api.spotify.com/v1/me/player/pause"
            );
        },
        resume_playback: function() {
            if (this.request_precheck()) {
                let device_id =
                    this.active_device.id ||
                    this.active_device_id ||
                    this.devices[0].id;
                this.$axios
                    .put("https://api.spotify.com/v1/me/player/play", null, {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        },
                        params: {
                            device_id: device_id
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "RPB", options);
                        }
                    });
                setTimeout(this.retrieve_currently_playing_information, 500);
            }
        },
        skip_next_track: function() {
            this.no_response_axios_post_request(
                "https://api.spotify.com/v1/me/player/next"
            );
        },
        skip_previous_track: function() {
            this.no_response_axios_post_request(
                "https://api.spotify.com/v1/me/player/previous"
            );
        },
        no_response_axios_post_request: function(url) {
            if (this.request_precheck()) {
                this.$axios
                    .post(url, null, {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "TPB", options);
                        }
                    });
                setTimeout(this.retrieve_currently_playing_information, 500);
            }
        },
        no_response_axios_put_request: function(url) {
            if (this.request_precheck()) {
                this.$axios
                    .put(url, null, {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "TPB", options);
                        }
                    });
                setTimeout(this.retrieve_currently_playing_information, 500);
            }
        },
        retrieve_available_devices: function() {
            if (this.request_precheck()) {
                this.$axios
                    .get("https://api.spotify.com/v1/me/player/devices", {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        },
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    })
                    .then(response =>
                        this.load_available_devices(response.data)
                    )
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "RAD", options);
                        }
                    });
            }
        },
        load_available_devices: function(spotify_response) {
            if (spotify_response !== "") {
                this.devices = spotify_response.devices;

                let select_values = [],
                    dictionary = {};
                for (let device of spotify_response.devices) {
                    select_values.push({
                        text: device.name,
                        value: device.id
                    });
                    dictionary[device.id] = {
                        name: device.name,
                        type: device.type,
                        icon: `mdi-${this.device_icons[device.type]}`
                    };
                }

                this.devices_list = select_values;
                this.devices_dict = dictionary;
            }
        },
        retrieve_currently_playing_information: function() {
            if (this.request_precheck()) {
                this.$axios
                    .get("https://api.spotify.com/v1/me/player", {
                        headers: {
                            Authorization: `Bearer ${this.$spotify_credentials.access_token}`
                        },
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    })
                    .then(response => this.load_cpi_information(response.data))
                    .catch(error => {
                        if (error.response) {
                            let options = {
                                user: false,
                                console: true
                            };
                            this.handle_errors(error.response, "RCPI", options);
                        }
                    });
            }
        },
        load_cpi_information: function(spotify_response) {
            if (spotify_response !== "" && spotify_response.item !== null) {
                this.playback = true;

                if (spotify_response.context !== null) {
                    this.context.type = spotify_response.context.type;
                    this.context.uri = spotify_response.context.uri;

                    if (this.context.type === "playlist") {
                        this.get_playlist_details(
                            this.context.uri.split(":").pop(),
                            this.playlist_information_callback
                        );
                    } else {
                        this.context.playlist_info.id = null;
                        this.context.playlist_info.name = null;
                        this.context.playlist_info.uri = null;
                        this.context.playlist_info.description = null;
                        this.context.playlist_info.owner = null;
                        this.context.playlist_info.public = null;
                        this.context.playlist_info.collaborative = null;
                        this.context.playlist_info.tracks = null;
                    }
                }

                this.playing = spotify_response.is_playing;
                this.shuffle = spotify_response.shuffle_state;
                this.repeat = spotify_response.repeat_state;

                this.active_device.id = spotify_response.device.id;
                this.active_device.name = spotify_response.device.name;
                this.active_device.type = spotify_response.device.type;
                this.active_device.icon = `mdi-${
                    this.device_icons[spotify_response.device.type]
                }`;

                this.volume.spotify = spotify_response.device.volume_percent;

                this.track_info.id = spotify_response.item.id;
                this.track_info.title = spotify_response.item.name;
                this.track_info.artists = spotify_response.item.artists.map(
                    artist => artist.name
                );
                this.track_info.album.id = spotify_response.item.album.id;
                this.track_info.album.name = spotify_response.item.album.name;
                this.track_info.album.artwork_url =
                    spotify_response.item.album.images[0].url;
                this.track_info.progress = spotify_response.progress_ms;
                this.track_info.duration = spotify_response.item.duration_ms;
                this.check_saved(spotify_response.item.id);
                this.track_info.explicit = spotify_response.item.explicit;
            } else {
                this.playback = false;
            }
        },
        rnt_precheck: function(override_time_check) {
            if (override_time_check) {
                return true;
            } else {
                return (
                    typeof this.$spotify_credentials.refresh_token !==
                        "undefined" &&
                    new Date().getTime() - this.refresh.interval_start >=
                        1800000
                );
            }
        },
        retrieve_new_tokens: function(override_time_check = false) {
            if (
                this.request_precheck() &&
                this.$spotify_credentials.refresh_token !== "" &&
                this.rnt_precheck(override_time_check)
            ) {
                let d = new Date();
                console.log(
                    `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] Retrieving new tokens...`
                );
                this.$axios
                    .post(
                        "https://accounts.spotify.com/api/token",
                        this.$qs.stringify({
                            grant_type: "refresh_token",
                            refresh_token: this.$spotify_credentials
                                .refresh_token
                        }),
                        {
                            headers: {
                                Authorization:
                                    "Basic " +
                                    btoa(
                                        this.$information.client_id +
                                            ":" +
                                            this.$information.client_secret
                                    ),
                                "Content-Type":
                                    "application/x-www-form-urlencoded"
                            }
                        }
                    )
                    .then(response => response.data)
                    .then(data => this.store_spotify_tokens(data))
                    .catch(error => {
                        if (error.response) {
                            if (
                                error.response.data.error !=
                                    "invalid_request" &&
                                error.response.data.error_description !=
                                    "refresh_token must be supplied"
                            ) {
                                let options = {
                                    user: false,
                                    console: true
                                };
                                this.handle_errors(
                                    error.response,
                                    "RNT",
                                    options
                                );
                            }
                        }
                    });
            }
        },
        start_refresh_interval: function(timeout) {
            if (this.$spotify_credentials.access_token !== "") {
                let d = new Date();
                console.log(
                    `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] Starting new refresh interval...`
                );
                this.refresh.interval_start = d.getTime();
                this.refresh.interval = setInterval(
                    this.retrieve_new_tokens,
                    timeout
                );
            }
        },
        store_spotify_tokens: function(response_data) {
            let d = new Date();
            console.log(
                `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] Storing Spotify tokens...`
            );

            this.$spotify_credentials.access_token = response_data.access_token;
            this.$spotify_credentials.expires_in = Number(
                response_data.expires_in
            );

            if (this.$spotify_credentials.refresh_token !== "") {
                clearInterval(this.refresh.interval);
                this.start_refresh_interval(response_data.expires_in - 120);
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.refresh.interval);
        clearInterval(this.main_interval);
    }
};
</script>

<style scoped>
body {
    text-align: center;
    padding: 20px;
}
@media (min-width: 768px) {
    body {
        padding-top: 150px;
    }
}
main {
    display: block;
    text-align: left;
    max-width: 650px;
    margin: 0 auto;
}

/* Size Dependents */
.hidden-md-and-down .col-3 {
    flex: 0 0 35%;
    max-width: 35%;
}
.hidden-md-and-down img#album_artwork {
    width: 75%;
}
.hidden-md-and-down div#name_metadata * {
    margin: 7px 0;
}
.hidden-lg-and-up div#name_metadata * {
    margin: 2.5px 0;
}

/* Metadata */
h2#song_name {
    font-weight: 900;
}
span#artists {
    font-weight: bold;
}
span#playlist_name {
    font-weight: 300;
}

/* Controls */
div#playback_controls div.col,
div#extra_controls div.col {
    text-align: center;
}

/* Text Styles */
.text-style--bold {
    font-weight: bold;
}
.color--green {
    color: green;
}
</style>
